import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {CustomsValidators} from '../../validators/custom.validators';
import {Observable, throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminSubZoneService {
  urlSubZoneAdmin: string;
  urlSubZoneAdminQDummy: string;
  urlAdminApprover: string;
  urlFacilitySubZone: string;

  constructor(private http: HttpClient) {
    this.urlSubZoneAdmin = `${environment.bffBaseUrl}/pages/admin-subzones`;
    this.urlSubZoneAdminQDummy = `${environment.bffBaseUrl}/pages/admin-Subzones/qualification/`;
    this.urlAdminApprover = `${environment.bffBaseUrl}/pages/approvers-subzone`;
    this.urlFacilitySubZone = `${environment.bffBaseUrl}/pages/admin-subzones/Facilities/`;
  }

  getAdminSubZoneList(id, page, limit) {
    const urlBuilder = this.urlSubZoneAdmin + '?zoneId=' + id + '&page=' + page + '&limit=' + limit + '&desc=false';
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  postAdminSubZone(zone, zoneId) {
    const urlBuilder = this.urlSubZoneAdmin;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, {
      Name: zone.Name, CodeCC: zone.CodeCC, Code1Sap: zone.Code1Sap, Description: zone.Description,
      ZoneId: parseInt(zoneId, 10)
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }

  putAdminSubZone(zone) {
    const urlBuilder = this.urlSubZoneAdmin + '/' + zone.Id;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.put(urlBuilder, {
      Id: zone.Id,
      ZoneId: zone.ZoneId,
      Name: zone.Name,
      CodeCC: zone.CodeCC,
      Code1Sap: zone.Code1Sap,
      isEnabled: zone.isEnabled,
      Description: zone.Description
    }) : throwError(CustomsValidators.msgNotValidUrl);

  }

  getAdminZoneDummy(id) {
    const urlBuilder = this.urlSubZoneAdminQDummy + id;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }


  postSubZoneQualificationDummy(data): Observable<any> {
    const urlBuilder = this.urlSubZoneAdminQDummy + data.subZoneId;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, data) : throwError(CustomsValidators.msgNotValidUrl);
  }

  putSubZoneQualificationDummy(data): Observable<any> {
    const urlBuilder = this.urlSubZoneAdminQDummy + data.subZoneId;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.put(urlBuilder, data) : throwError(CustomsValidators.msgNotValidUrl);
  }


  // ----facility

  getFacility(idZone) {
    const urlBuilder = this.urlFacilitySubZone + idZone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  patchFacility(request) {
    const urlBuilder = this.urlFacilitySubZone + request.subZoneId;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.patch(urlBuilder, request) : throwError(CustomsValidators.msgNotValidUrl);
  }


  searchApprover(type, ID, nationality, siteId): Observable<any> {
    let national = '';
    if (nationality !== '') {
      national = '&nationality=' + nationality;
    }
    const urlBuilder = this.urlAdminApprover + '/validate' + '?documentType=' + type
      + '&documentNumber=' + ID + national + '&siteId=' + siteId;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }


}


